<template>
  <div>
    <b-container fluid class="px-5">
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow title="Modifier une espèce"/>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b-form @submit.stop.prevent="onSubmit">

          <b-form-group
            id="name-input"
            label="Nom *"
            label-for="name-input"
            class="bold-label"
            :invalid-feedback="form.name.invalidFeedback"
            :state="form.name.state"
          >
            <b-form-input
              id="name-input"
              v-model="form.name.value"
              type="text"
              maxlength="250"
              :state="form.name.state"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="family-input"
            label="Famille *"
            label-for="family-input"
            class="bold-label"
            :invalid-feedback="form.family.invalidFeedback"
            :state="form.family.state"
          >
            <b-form-select
              id="family-input"
              v-model="form.family.value"
              :options="families"
              :state="form.family.state"
              required
            ></b-form-select>
          </b-form-group>

          <food-selection
            v-if="species"
            :foods="foods"
            :initSelectedFoods="form.foods.value"
            @didChangeSelectedFoods="didChangeSelectedFoods"
          />

          <div class="d-flex justify-content-end">
            <b-button type="submit" variant="secondary" :disabled="sendButtonDisabled">Valider</b-button>
          </div>
        </b-form>

      </b-card>
    </b-container>
  </div>
</template>

<script>

import api from '../../services/api';
import BackArrow from "../../components/BackArrow";
import FoodSelection from "../food/FoodSelection";

export default {

  name: 'SpeciesEdit',

  components: {
    BackArrow,
    FoodSelection
  },

  data() {
    return {
      sendButtonDisabled: false,

      speciesId: this.$route.params.speciesId,
      species: null,
      families: [],
      foods: [],

      form: {

        family: {
          state: null,
          invalidFeedback: null,
          value: null
        },

        name: {
          state: null,
          invalidFeedback: null,
          value: null
        },

        foods: {
          value: null
        }

      }
    }
  },

  mounted () {
    this.fetchData()
  },

  methods: {

    fetchData() {
      this.fetchFamilies()
      this.fetchSpecies()
      this.fetchFoods()
    },

    fetchFamilies() {
      api
        .get(`/family`)
        .then(response => {
          this.families = response.data.map(family => ({
            value: family.id,
            text: family.name
          }))
        })
    },

    fetchSpecies() {
      api
        .get(`/species/${this.speciesId}`)
        .then(response => {
          this.species = response.data
          this.setInitialValues()
        })
    },

    fetchFoods() {
      api
        .get(`/food`)
        .then(response => {
          this.foods = response.data
        })
    },

    setInitialValues() {
      this.form.name.value = this.species.name
      this.form.family.value = this.species.family.id
      this.form.foods.value = this.species.foodsIds
    },

    didChangeSelectedFoods(selectedFoods) {
      this.form.foods.value = selectedFoods
    },

    onSubmit() {
      this.sendButtonDisabled = true

      let data = new FormData()
      data.append('name', this.form.name.value)
      data.append('familyId',  this.form.family.value)
      data.append('foods', JSON.stringify(this.form.foods.value))

      api({
        method: 'POST',
        url: `/species/${this.species.id}`,
        data: data
      })
        .then((response) => {
          this.$router.push({
            name: 'SpeciesShow',
            params: {
              speciesId: this.species.id
            }
          }, () => {
            this.$nextTick(() => {
              this.successToast(this.form.name.value)
            })
          })
        })
        .catch((error) => {
          this.sendButtonDisabled = false
          if (error.response.status === 418) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]["state"] = false
            this.form[invalidField]["invalidFeedback"] = error.response.data.message
          }
        });
    },

    successToast(speciesName) {
      this.$bvToast.toast(`Espèce \"${speciesName}\" modifié`, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/species/SpeciesEdit.vue